import { render, staticRenderFns } from "./details-shipment.vue?vue&type=template&id=75835154&scoped=true&"
import script from "./details-shipment.vue?vue&type=script&lang=js&"
export * from "./details-shipment.vue?vue&type=script&lang=js&"
import style0 from "./details-shipment.vue?vue&type=style&index=0&id=75835154&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75835154",
  null
  
)

export default component.exports